import HttpRequest from '@/plugins/axios'

class RefProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_CENTRAL_API_URL + 'reference/')
  }

  async getLevel() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'LEVEL',
      select: ["LEVEL_ID", "LEVEL_NAME_TH", "LEVEL_NAME_EN"],
      order: [JSON.stringify({
        LEVEL_ID: 'ASC'
      })]
    })
    return data
  }

  async getMatriculationStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'MATRICULATION_STATUS',
      select: ["MATRICULATION_STATUS_ID", "MATRICULATION_STATUS_NAME_TH", "MATRICULATION_STATUS_NAME_EN", "TEXT_CLASS"],
    })
    return data
  }

  async getUploadStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'MATRICULATION_UPLOAD_STATUS',
      select: ["UPLOAD_STATUS_ID", "UPLOAD_STATUS_NAME_TH", "UPLOAD_STATUS_NAME_EN"],
    })
    return data
  }

  async getGender() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'GENDER',
      select: ["GENDER_ID", "GENDER_NAME_TH", "GENDER_NAME_EN"],
    })
    return data
  }

  async getPrefixName() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PREFIX_NAME',
      select: ["PREFIX_NAME_ID", "FULLNAME_TH", "INITIALS_TH", "FULLNAME_EN", "INITIALS_EN", "GENDER", "AGE", "ENABLED"],
    })
    return data
  }

  async getNation() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'NATION',
      select: ["NATION_ID", "NATION_NAME_TH", "NATION_NAME_EN"],
    })
    return data
  }

  async getRace() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'RACE',
      select: ["RACE_ID", "RACE_NAME_TH", "RACE_NAME_EN"],
    })
    return data
  }

  async getReligion() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'RELIGION',
      select: ["RELIGION_ID", "RELIGION_NAME_TH", "RELIGION_NAME_EN"],
    })
    return data
  }

  async getProvince() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PROVINCE',
      select: ["PROVINCE_ID", "PROVINCE_NAME_TH", "PROVINCE_NAME_EN", "GEOGRAPHY_ID"],
    })
    return data
  }

  async getSubDistrict() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SUB_DISTRICT',
      select: ["SUB_DISTRICT_ID", "SUB_DISTRICT_NAME_TH", "SUB_DISTRICT_NAME_EN", "DISTRICT_ID", "PROVINCE_ID"],
    })
    return data
  }

  async getDistrict() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'DISTRICT',
      select: ["DISTRICT_ID", "DISTRICT_NAME_TH", "DISTRICT_NAME_EN", "PROVINCE_ID"],
    })
    return data
  }

  async getTalent() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'TALENT',
      select: ["TALENT_ID", "TALENT_NAME_TH", "TALENT_NAME_EN"],
    })
    return data
  }

  async getRevenue() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'REVENUE',
      select: ["REVENUE_ID", "REVENUE_NAME_TH", "REVENUE_NAME_EN"],
    })
    return data
  }

  async getParRelative() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PAR_RELATIVE',
      select: ["PAR_RELATIVE_ID", "PAR_RELATIVE_NAME_TH", "PAR_RELATIVE_NAME_EN"],
    })
    return data
  }
  async getOccupation() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'OCCUPATION',
      select: ["OCCUPATION_ID", "OCCUPATION_NAME_TH", "OCCUPATION_NAME_EN"],
    })
    return data
  }

  async getParStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PAR_STATUS',
      select: ["PAR_STATUS_ID", "PAR_STATUS_NAME_TH", "PAR_STATUS_NAME_EN"],
    })
    return data
  }

  async getSchoolType() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SCHOOL_TYPE',
      select: ["SCHOOL_TYPE_ID", "SCHOOL_TYPE_NAME_TH", "SCHOOL_TYPE_NAME_EN"],
    })
    return data
  }

  async getEducationType() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'EDUCATION_TYPE',
      select: ["EDUCATION_TYPE_ID", "EDUCATION_TYPE_NAME_TH", "EDUCATION_TYPE_NAME_EN"],
    })
    return data
  }

  async getSchool() {
    const { data } = await this.get('/', {
      function: 'get-registrar-reference',
      table: 'school',
      select: ["SCHOOL_CODE", "SCHOOL_NAME", "ADDR", "MOO", "SOI", "STREET", "TMBL_NAME", "AMPH_NAME", "PROV_NAME", "ZIPCODE", "PROV_ID", "TEL"],
    })
    return data
  }

  async getSpecificNation() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SPECIFIC_NATION',
      select: ["SPECIFIC_NATION_ID", "SPECIFIC_NATION_NAME_TH", "SPECIFIC_NATION_NAME_EN"],
    })
    return data
  }

  async getUniversity() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'UNIVERSITY',
      select: ["UNIVERSITY_ID", "UNIVERSITY_PROVINCE_CODE", "UNIVERSITY_NAME_TH", "UNIVERSITY_NAME_EN"],
    })
    return data
  }

  async getUniversityStudyStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'UNIVERSITY_STUDY_STATUS',
      select: ["UNIVERSITY_STUDY_STATUS_ID", "UNIVERSITY_STUDY_STATUS_NAME_TH", "UNIVERSITY_STUDY_STATUS_NAME_EN"],
    })
    return data
  }

  async getDisability() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'DISABILITY',
      select: ["DISABILITY_ID", "DISABILITY_NAME_TH", "DISABILITY_NAME_EN"],
    })
    return data
  }
  
  async getVitalStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'VITAL_STATUS',
      select: ["VITAL_STATUS_ID", "VITAL_STATUS_NAME_TH", "VITAL_STATUS_NAME_EN"],
    })
    return data
  }
}

export default RefProvider